import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-09ca9d3c")

_pushScopeId("data-v-09ca9d3c")
const _hoisted_1 = { class: "file-viewer-dialog" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-title -bold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 첨부파일 ")
const _hoisted_5 = { class: "header-file" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "file-image",
  src: "/images/new/file.svg"
}, null, -1)
const _hoisted_7 = { class: "file-info" }
const _hoisted_8 = {
  key: 0,
  class: "file__down"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("다운로드")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_FileViewer = _resolveComponent("FileViewer")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Sidebar, {
      visible: _ctx.state.visibleFull,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.visibleFull = $event)),
      baseZIndex: 1000,
      position: "full"
    }, {
      header: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            (_ctx.$slots.title)
              ? _renderSlot(_ctx.$slots, "title", { key: 0 }, undefined, true)
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_4
                ], 64))
          ]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, _toDisplayString(_ctx.state.file.Title), 1),
              _createVNode("span", null, _toDisplayString(_ctx.state.file.FileType), 1)
            ]),
            (_ctx.downloadPath && _ctx.state.file.PrescriptionFlag)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    class: "-button",
                    onClick: _ctx.download,
                    target: "_blank"
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withId(() => [
        (_ctx.state.file)
          ? (_openBlock(), _createBlock(_component_FileViewer, {
              key: 0,
              select: _ctx.state.file,
              isSidebar: false
            }, null, 8, ["select"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
})